/** Kleine Formatierungs-Helfer (Datum, Countdown, Dateigröße). */

export function formatDate(iso: string): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/** ISO -> Wert für <input type="date"> (YYYY-MM-DD). */
export function toDateInput(iso: string): string {
  if (!iso) return "";
  return iso.slice(0, 10);
}

export function daysUntil(iso: string): number | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(d);
  target.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / 86400000);
}

export function formatCountdown(iso: string): string {
  const n = daysUntil(iso);
  if (n === null) return "";
  if (n === 0) return "heute";
  if (n === 1) return "morgen";
  if (n === -1) return "gestern";
  if (n < 0) return `vor ${Math.abs(n)} Tagen`;
  return `in ${n} Tagen`;
}

export function formatBytes(bytes?: number): string {
  if (bytes == null) return "";
  const units = ["B", "KB", "MB", "GB"];
  let v = bytes;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(i > 0 && v < 10 ? 1 : 0)} ${units[i]}`;
}

/** Wörter in Markdown-Quelltext – Auszeichnungszeichen zählen nicht mit. */
export function wordCount(markdown: string): number {
  const text = markdown
    .replace(/```[\s\S]*?```/g, " ")
    .replace(/^[ \t]*:::.*$/gm, " ")
    .replace(/[#>*`_~|[\](){}]/g, " ");
  const words = text.match(/[\p{L}\p{N}][\p{L}\p{N}'-]*/gu);
  return words ? words.length : 0;
}
